$(function() {
    $('.contact-form input, .contact-form select').blur(function() {
        if( $(this).val() != '' ) {
            $(this).closest('.contact-form__input').addClass('is-filled');
        } else {
            $(this).closest('.contact-form__input').removeClass('is-filled');
        }
    });
    
    $('.contact-form input[name="landingPageURL"]').val(location.hostname + location.pathname);

    var eu_countries = new Object;
    eu_countries['AT'] = 'Austria';
    eu_countries['BE'] = 'Belgium';
    eu_countries['BG'] = 'Bulgaria';
    eu_countries['HR'] = 'Croatia';
    eu_countries['CY'] = 'Cyprus';
    eu_countries['CZ'] = 'Czech Republic';
    eu_countries['DK'] = 'Denmark';
    eu_countries['EE'] = 'Estonia';
    eu_countries['FI'] = 'Finland';
    eu_countries['FR'] = 'France';
    eu_countries['DE'] = 'Germany';
    eu_countries['GR'] = 'Greece';
    eu_countries['HU'] = 'Hungary';
    eu_countries['IS'] = 'Iceland';
    eu_countries['IE'] = 'Ireland';
    eu_countries['IT'] = 'Italy';
    eu_countries['LV'] = 'Latvia';
    eu_countries['LI'] = 'Liechtenstein';
    eu_countries['LT'] = 'Lithuania';
    eu_countries['LU'] = 'Luxembourg';
    eu_countries['MT'] = 'Malta';
    eu_countries['NL'] = 'Netherlands';
    eu_countries['NO'] = 'Norway';
    eu_countries['PL'] = 'Poland';
    eu_countries['PT'] = 'Portugal';
    eu_countries['RO'] = 'Romania';
    eu_countries['SK'] = 'Slovakia';
    eu_countries['SI'] = 'Slovenia';
    eu_countries['ES'] = 'Spain';
    eu_countries['SE'] = 'Sweden';
    eu_countries['CH'] = 'Switzerland';
    eu_countries['GB'] = 'United Kingdom';
    
    $('.contact-form select[name="country"]').change(function() {		
		if( $(this).val() == 'US' ) {
			$('#states-container').show();
			$('#provinces-container').hide();
		} else if( $(this).val() == 'CA' ) {
			$('#provinces-container').show();
			$('#states-container').hide();
		} else {
			$('#states-container').hide();
			$('#provinces-container').hide();
        }
        
        if( $(this).val() in eu_countries ) {
            $('#terms-container').show();            
        } else {
            $('#terms-container').hide();
        }
    });

    $('.contact-form__submit button').on('click', function(){
        setTimeout(function(){
            $('.contact-form__input .formField').each(function(){
                if($(this).hasClass('error')){
                    $(this).closest('.contact-form__input').addClass('invalid');
                }else if($(this).hasClass('valid')){
                    $(this).closest('.contact-form__input').removeClass('invalid');
                }
            });
        }, 500);
    });
    $('.contact-form__input .formField').on('keyup', function(){
        var $invalidInput = $(this).closest('.contact-form__input');
        if($invalidInput.hasClass('invalid')){
            $invalidInput.removeClass('invalid');
        }
    });
    
    $('.contact').validate({ 
        submitHandler: function (form) { 
            form.submit();
        }
    });
    $.validator.addClassRules("formField", {
        required: true
    });
});